<template>
  <b-container 
    fluid
  >
    <b-card-title>
      Documentenbeheer
      <b-dropdown 
        id="dropdown-1" 
        :text="jaar.toString()" 
        class="m-md-2"
      >
        <b-dropdown-item-button
          v-for="i in new Date().getUTCFullYear() - startjaar"
          :key="i + startjaar"
          :active="jaar == (i+startjaar)"
          @click="jaarSwitch(i+startjaar)"
        >
          {{ (i+startjaar).toString() }}
        </b-dropdown-item-button>
      </b-dropdown>
      <b-button
        :to="{ name: 'upload-documenten' }"
        size="lg"
        variant="primary"
        class="pull-right"
      >
        <font-awesome-icon icon="upload" /> Upload document
      </b-button>
    </b-card-title>

    <b-input-group class="w-50 mb-2">
      <b-input-group-prepend 
        is-text
      >
        <i class="fa fa-search mr-2" /> Zoeken in {{ docs.length }} documenten
      </b-input-group-prepend>
      <b-input
        v-model="zoekVerwerkt"
        placeholder="Bijvoorbeeld: mo2,woningbedrijf,corr"
        debounce="300"
        type="search"
      />

      <b-dropdown>
        <template #button-content>
          Filter documenttypes ({{ filterTypes.length }} geselecteerd)
        </template>

        <b-dropdown-form>
          <div>
            <b-dropdown-item
              @click="
                () =>
                  filterTypes.length > 0
                    ? (filterTypes = [])
                    : (filterTypes = [...docTypes])
              "
            >
              Selecteer/deselecteer alles
            </b-dropdown-item>
          </div>
          <b-form-checkbox-group
            v-model="filterTypes"
            :options="docTypes"
            stacked
          />
        </b-dropdown-form>
      </b-dropdown>
      <!---<b-row v-if="searchParams.length > 0">Gezocht op: <b-badge 
        v-for="(tag) in searchParams" 
        :key="tag">{{ tag }}</b-badge>
      </b-row>--->
    </b-input-group>

    <router-view
      :relaties="relaties"
      :units="units"
      :docs="filterVerwerkt"
      :is-busy="busy"
      @update-row="UpdateRowData"
      @delete-row="DeleteRowData"
    />
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin.js";
export default {
  mixins: [serviceMixin],
  props: {
    jaar: {
      type: Number,
      default: new Date().getUTCFullYear(),
    },
  },
  data() {
    return {
      startjaar: 2018,
      relaties: [],
      units: [],
      busy: false,
      zoekVerwerkt: null,
      filterTypes: [
        "Geen",
        "p.a. Factuur",
        "Factuur/termijn",
        "Offerte",
        "PVB",
        "Keuring",
        "Kwartaaloverleg  ",
        "Algemeen",
        "Bestek",
        "Storingsoverzicht",
        "Factuur",
        "Onderhoudscontract",
        "Planning",
        "Intern document",
      ],
      docs: [],
      docTypes: [
        "Geen",
        "p.a. Factuur",
        "Factuur/termijn",
        "Offerte",
        "PVB",
        "Keuring",
        "Kwartaaloverleg  ",
        "Algemeen",
        "Bestek",
        "Storingsoverzicht",
        "Factuur",
        "Onderhoudscontract",
        "Planning",
        "Intern document",
      ],
    };
  },
  beforeRouteUpdate(to, from, next) {
    //console.dir(to);
    if (to.params.jaar !== from.params.jaar)
      this.getVerwerktedocumenten(to.params.jaar);
    next();
  },
  computed: {
    huidigJaar: function () {
      return new Date().getUTCFullYear();
    },
    searchParams: function () {
      if (!this.zoekVerwerkt) return [];
      return this.zoekVerwerkt.toLowerCase().split(",");
    },
    filterVerwerkt: function () {
      var term = this.searchParams;
      return this.docs.filter(
        (d) =>
          (term.every((t) => [d.Ke, d.Re, d.Un, d.Af, d.So, d.Un].some((n) => n.toLowerCase().includes(t.trim()))) ||
            term.length == 0) &&
          this.filterTypes.includes(d.Ty)
      );
    },
  },
  mounted() {
    this.getVerwerktedocumenten(this.jaar);
    this.getRelaties();
    this.getUnits();
  },
  methods: {
    UpdateRowData(row) {
      this.$set(this.docs, this.docs.map((d) => d.Id).indexOf(row.Id), row);
    },
    DeleteRowData(id) {
      this.$delete(this.docs, this.docs.map((d) => d.Id).indexOf(id));
    },
    jaarSwitch(j) {
      this.$router.push({ name: "Documenten", params: { jaar: j } });
    },
    getUnits() {
      var vm = this;
      this.get("/units/zoeken/1")
        .then(function (response) {
          vm.units = response.data.units;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getRelaties() {
      var vm = this;
      this.get("/relaties")
        .then(function (response) {
          vm.relaties = response.data.relaties;
        })
        .catch(function (error) {
          vm.error = error;
        });
    },
    getVerwerktedocumenten(j) {
      console.log("verwerkte documenten ophalen");
      var vm = this;
      this.busy = true;
      this.get("/documenten/" + Number(j))
        .then(function (response) {
          vm.docs = response.data.documenten;
        })
        .catch(function (error) {
          vm.docparser.error = error;
        })
        .then(() => (vm.busy = false));
    },
    getTeVewerkenDocumenten() {
      var vm = this;
      this.get("/documenten/teverwerken")
        .then(function (response) {
          vm.docs = response.data.documenten;
        })
        .catch(function (error) {
          vm.docparser.error = error;
        })
        .then(() => (vm.busy = false));
    },
  },
};
</script>